import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from '../images/techStart.png';
import { getCurrentUser } from "../reducers/login";
import slackIcon from '../images/slack-color.svg';
import readingIcon from '../images/reading.png';
import lessonIcon from '../images/homework.png';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const free = this.props?.currentUser?.optional?.groups?.some(el => el.includes('FREE'));

        return (
            <div className='text-center home'>
                <div>
                    <p className='description'>
                        Hi {this.props.currentUser.firstName} {this.props.currentUser.lastName}!
                    </p>
                    {free ? <div>
                        <h3>
                            Welcome onboard!
                        </h3>
                        <img src={logo} className="logo" alt="logo" />
                        <p className='description'>
                            What to do next:
                        </p>
                        {/* <p>
                            The course has started! But you can still join the remaining
                            <a href='https://meet.google.com/zdu-zudj-uqs' target='_blank' rel="noreferrer" style={{ marginRight: '5px' }}>
                                <img style={{ height: '2rem', opacity: '1', paddingBottom: '10px', marginLeft: '10px', marginRight: '5px' }} src={lessonIcon} alt='call' />
                                online video lessons
                            </a>
                            on Tuesdays and Wednesdays at 7PM Pacific Time.
                        </p>
                        <p>
                            Visit the
                            <a href="/lessons/FREE-11" style={{ marginRight: '5px' }}>
                                <img style={{ height: '1.5rem', opacity: '1', paddingBottom: '5px', marginLeft: '10px', marginRight: '5px' }} src={readingIcon} alt='courses' />
                                Course Page
                            </a>
                            to watch and complete the previous lessons.
                        </p> */}
                        <p>
                            Just join the first online video lesson using the link below on <strong>July 11th at 7PM Pacific Time</strong> and get answers for all your questions.
                        </p>
                        <p><a href='https://meet.google.com/izn-fhfn-mvs' target='_blank' rel="noreferrer" style={{ marginRight: '5px' }}>
                            👉 online video lesson link 👈
                        </a></p>
                        <p className='description'>
                            Also, you will need to:
                        </p>
                        <p>
                            Register in our
                            <a href='https://join.slack.com/t/t-start/shared_invite/zt-1wj690u9i-zjQ5N9mQKttq2PMU7tH6tA' target='_blank' rel="noreferrer">
                                <img style={{ height: '2rem', width: '2rem', opacity: '1', paddingBottom: '5px' }} src={slackIcon} alt='slack' />
                                Slack</a> to communicate with our team and other students.
                        </p>
                        {/* <p>
                            Visit the <a href="/lessons">
                                <img style={{ height: '1.5rem', opacity: '1', paddingBottom: '5px', marginRight: '5px' }} src={readingIcon} alt='courses' />
                                Courses Page</a>
                        </p> */}
                    </div>
                        :
                        <div>
                            <h3>
                                Welcome to TechStart!
                            </h3>
                            <img src={logo} className="logo" alt="logo" />
                        </div>
                    }
                </div>
            </div >
        );
    }
}

const mapStateToProps = state => ({
    currentUser: getCurrentUser(state),
});

export default connect(mapStateToProps)(Home);